import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { NsideIdentityService } from './nSideIdentityService';
import { map, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class NsideIdentityGuard implements CanActivate {
  private readonly nSideIdentityService: NsideIdentityService = inject(NsideIdentityService);

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    if (!isPlatformBrowser(this.platformId)) {
      // If it's not the browser platform, likely server-side rendering, disable the route
      return false;
    }

    localStorage.setItem("current_route", state.url);

    // Check authentication status
    return this.nSideIdentityService.checkAuth().pipe(
      map(authData => {
        if (!authData.isAuthenticated) {
          // Trigger the login process and redirect after login
          this.nSideIdentityService.login(state.url);  // Assume login method can handle the returnUrl
          return this.router.parseUrl('/unauthorized'); // Redirect to login if not authenticated
        }
        return true; // Proceed to the route if authenticated
      })
    );
  }
}
